__turbopack_context__.v({
  "swiperPagination": "HeroSection-module__R91VQG__swiperPagination",
  "swiperPaginationBullet": "HeroSection-module__R91VQG__swiperPaginationBullet",
  "swiperPaginationBulletActive": "HeroSection-module__R91VQG__swiperPaginationBulletActive",
  "swiperPaginationBulletInactive": "HeroSection-module__R91VQG__swiperPaginationBulletInactive",
});
